var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.95 3.5C9.07405 3.5 3.5 9.07405 3.5 15.95C3.5 22.8259 9.07405 28.4 15.95 28.4C22.8259 28.4 28.4 22.8259 28.4 15.95C28.4 9.07405 22.8259 3.5 15.95 3.5ZM0.5 15.95C0.5 7.4172 7.4172 0.5 15.95 0.5C24.4828 0.5 31.4 7.4172 31.4 15.95C31.4 24.4828 24.4828 31.4 15.95 31.4C7.4172 31.4 0.5 24.4828 0.5 15.95Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.83 12.43C11.83 9.86 14.18 7.84 16.84 8.4C18.4 8.72 19.66 9.98 19.98 11.54C20.42 13.63 19.27 15.52 17.51 16.24C16.54 16.64 15.94 17.62 15.94 18.67",
    stroke: "#FFB6BF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.95 22.86V23.86",
    stroke: "#FFB6BF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelp);
export default __webpack_public_path__ + "static/media/ic_help.f0dbaabcd937914c11ab6819cf5f964d.svg";
export { ForwardRef as ReactComponent };